import * as types from '../types.js';

export default {

	html: `
		<style>
			#integration_event #id		{ width: 6rem; text-align: right;	}
			#integration_event #date_time	{ width: 10rem;	}
			#integration_event #company_id	{ width: 12rem;	}
			#integration_event #integration_key	{ width: 14rem;	}
			#integration_event #direction	{ width: 8rem;	}
			#integration_event #status	{ width: 8rem;	}
			#integration_event .summary	{ width: 100%;	}
			#integration_event #entity_type	{ width: 12rem;	}
			#integration_event #entity_id	{ width: 14rem;	}
			#integration_event .error_message	{ width: 100%;	}
			#integration_event #correlation_id	{ width: 20rem;	}
			#integration_event #source	{ width: 14rem;	}
			#integration_event #recorded_by	{ width: 12rem;	}
			#integration_event .payload	{ width: 100%;	}
		</style>
		<form id="integration_event" class="form" autocomplete="off">
			<datalist id="iev_companies">
			</datalist>
			<datalist id="iev_users">
			</datalist>
			<div class="fsb">
				<label title="Identificador">Evento
					<input id="id" type="text" disabled>
				</label>
				<label title="Data e hora">Data/Hora
					<input id="date_time" type="text" disabled>
				</label>
				<label title="Empresa">Empresa
					<input id="company_id" type="text" list="iev_companies" disabled>
				</label>
				<label title="Chave da integração">Integração
					<input id="integration_key" type="text" disabled>
				</label>
				<label title="Direção">Direção
					<input id="direction" type="text" disabled>
				</label>
				<label title="Status">Status
					<input id="status" type="text" disabled>
				</label>
			</div>
			<div>
				<label class="summary" title="Resumo">Resumo
					<input id="summary" type="text" disabled>
				</label>
			</div>
			<div class="fsb">
				<label title="Tipo da entidade">Tipo entidade
					<input id="entity_type" type="text" disabled>
				</label>
				<label title="ID da entidade">ID entidade
					<input id="entity_id" type="text" disabled>
				</label>
				<label title="UUID de correlação">Correlação
					<input id="correlation_id" type="text" disabled>
				</label>
				<label title="Origem">Origem
					<input id="source" type="text" disabled>
				</label>
				<label title="Usuário">Registrado por
					<input id="recorded_by" type="text" list="iev_users" disabled>
				</label>
			</div>
			<div>
				<label class="error_message" title="Mensagem de erro">Erro
					<textarea id="error_message" rows="3" disabled></textarea>
				</label>
			</div>
			<div>
				<label class="payload" title="Request (JSON)">Request
					<textarea id="request_payload" rows="6" disabled></textarea>
				</label>
			</div>
			<div>
				<label class="payload" title="Response (JSON)">Response
					<textarea id="response_payload" rows="6" disabled></textarea>
				</label>
			</div>
			<div>
				<label class="payload" title="Stack trace">Stack
					<textarea id="error_stack" rows="6" disabled></textarea>
				</label>
			</div>
			<div class="tar">
				<button class='bn_Escape button'>Fechar</button>
			</div>
		</form>
	`,

	form:
	{
		selector: '#integration_event',
		init(formset)
		{
			formset.loadList('#iev_companies', 'companies');
			formset.loadList('#iev_users', 'users');
			Object.getPrototypeOf(this).init.call(this);
		},
	},

	fields: [
		{ properties: { selector: '#id' }, types: [types.number(0, 2)] },
		{ properties: { selector: '#date_time' }, types: [types.datetime()] },
		{ properties: { selector: '#company_id' }, types: [types.datalist()] },
		{ properties: { selector: '#integration_key' }, types: [] },
		{ properties: { selector: '#direction' }, types: [] },
		{ properties: { selector: '#status' }, types: [] },
		{ properties: { selector: '#summary' }, types: [] },
		{ properties: { selector: '#entity_type' }, types: [] },
		{ properties: { selector: '#entity_id' }, types: [] },
		{ properties: { selector: '#correlation_id' }, types: [] },
		{ properties: { selector: '#source' }, types: [] },
		{ properties: { selector: '#recorded_by' }, types: [types.datalist()] },
		{ properties: { selector: '#error_message' }, types: [types.textarea()] },
		{ properties: { selector: '#request_payload' }, types: [types.textarea()] },
		{ properties: { selector: '#response_payload' }, types: [types.textarea()] },
		{ properties: { selector: '#error_stack' }, types: [types.textarea()] },
	]

};
